<button
  type="button"
  class="ml-2 flex h-9 w-9 items-center justify-center rounded-full p-1.5 transition focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-800 focus-visible:ring-indigo-400"
  [ngClass]="getSoundStateClass(soundEnabled)"
  [attr.aria-label]="
    soundEnabled === true ? 'Notification sound enabled' :
    soundEnabled === false ? 'Notification sound disabled. Click to enable.' :
    'Notification sound permission required. Click to enable.'
  "
  [title]="
    soundEnabled === true ? 'Notification sound enabled' :
    soundEnabled === false ? 'Notification sound disabled. Click to enable.' :
    'Notification sound permission required. Click to enable.'
  "
  (click)="soundEnabled !== true && requestPermission()"
>
  <ng-container [ngSwitch]="getSoundIcon(soundEnabled)">
    <!-- Enabled: speaker with sound waves -->
    <svg *ngSwitchCase="'enabled'" class="h-5 w-5 text-green-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.75" aria-hidden="true">
      <path stroke-linecap="round" stroke-linejoin="round" d="M19.114 5.636a9 9 0 010 12.728M16.463 8.288a5.25 5.25 0 010 7.424M6.75 8.25l4.72-4.72a.75.75 0 011.28.53v15.88a.75.75 0 01-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.507-1.938-1.354A9.01 9.01 0 012.25 12c0-.83.112-1.633.322-2.396C2.806 8.756 3.63 8.25 4.51 8.25H6.75z" />
    </svg>
    <!-- Disabled: muted speaker -->
    <svg *ngSwitchCase="'disabled'" class="h-5 w-5 text-red-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.75" aria-hidden="true">
      <path stroke-linecap="round" stroke-linejoin="round" d="M17.25 9.75L19.5 12m0 0l2.25 2.25M19.5 12l2.25-2.25M19.5 12l-2.25 2.25m-10.5-6l4.72-4.72a.75.75 0 011.28.53v15.88a.75.75 0 01-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.507-1.938-1.354A9.01 9.01 0 012.25 12c0-.83.112-1.633.322-2.396C2.806 8.756 3.63 8.25 4.51 8.25H6.75z" />
    </svg>
    <!-- Undecided: question mark -->
    <svg *ngSwitchCase="'undecided'" class="h-5 w-5 text-amber-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.75" aria-hidden="true">
      <path stroke-linecap="round" stroke-linejoin="round" d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z" />
    </svg>
  </ng-container>
</button>
